import { Paso } from './Paso';

export class PasoGabinete extends Paso {
  constructor() {
    super(
      true,
      'Gabinete',
      `Es fundamental para el armado de la pc ya que contendrá todos los componentes funcionales de la misma. Podés revisar las medidas en el botón de especificaciones`,
      8,
      'case.png',
      'case.png',
      true,
      [],
      '',
    );
  }
}
